<template>
  <header
    class="bg-white shadow-md py-3 px-4 flex items-center justify-between"
  >
    <!-- Desktop Logo -->
    <div class="hidden md:flex justify-center items-center">
      <router-link to="/portal">
        <img
          :src="require('@/assets/IMF.svg')"
          alt="IMF header"
          class="w-20 h-16"
        />
      </router-link>
    </div>

    <!-- Mobile Greeting with Profile on the right -->
    <div class="flex md:hidden justify-between items-center w-full">
      <div class="flex flex-col">
        <span class="text-gray-500 text-sm font-semibold">Welcome!</span>
        <span class="text-gray-800 text-lg">{{ getGivenName }}</span>
      </div>
      <router-link to="/portal/account/profile">
        <img
          class="w-14 h-14 object-cover rounded-full"
          :src="getProfileAvatar"
          alt="Profile"
        />
      </router-link>
    </div>

    <!-- Dropdown menu (desktop only) -->
    <div class="relative hidden lg:block">
      <button
        @click="toggleDropdown"
        class="text-gray-700 font-medium flex items-center space-x-2 hover:text-blue-600 transition"
      >
        <span>{{ $store.state.userLogged }}</span>
        <ChevronDown />
      </button>

      <div
        v-if="isDropdownOpen"
        class="fixed inset-0 z-40"
        @click.self="isDropdownOpen = false"
      >
        <div
          class="absolute right-4 top-16 w-48 bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-64 overflow-auto"
        >
          <ul class="text-sm text-gray-700 divide-y divide-gray-100">
            <li v-for="(item, index) in itemList" :key="index">
              <router-link
                @click.self="isDropdownOpen = false"
                :to="item.route"
                class="flex justify-between items-center px-4 py-3 hover:bg-gray-50"
              >
                <span>{{ item.name }}</span>
                <span
                  v-if="item.name === 'Electronic Files'"
                  class="text-[10px] font-semibold uppercase bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 px-2 py-1 rounded-full shadow-sm tracking-wide"
                >
                  Soon
                </span>
              </router-link>
            </li>

            <li>
              <button
                class="w-full text-left px-4 py-3 hover:bg-red-50 text-red-600 font-medium"
                @click="handleLogout"
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, inject, computed } from "vue";
import { useRouter } from "vue-router";
import ChevronDown from "@/components/svgs/chevronDown.vue";
import BookSVG from "@/components/svgs/BookSvg.vue";
import HelpSVG from "@/components/svgs/HelpSvg.vue";

export default {
  components: { ChevronDown },
  setup() {
    const isDropdownOpen = ref(false);
    const router = useRouter();
    const axios = inject("$axios");
    const store = inject("$store");
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };
    const itemList = ref([
      {
        id: 1,
        name: "My Profile",
        route: "/portal/account/profile",
      },
      {
        id: 2,
        name: "Transaction History",
        route: "/portal/transaction",
      },
      {
        id: 3,
        name: "Electronic Files",
        route: "/portal/transaction",
      },

      {
        id: 4,
        name: "Account Setting",
        route: "/portal/account/setting",
      },
      /*
      {
        id: 5,
        name: "User Guidelines",
        route: "/portal/account/setting",
      },*/
      {
        id: 6,
        name: "System About",
        route: "/portal/account/setting/about",
      },
    ]);
    const handleLogout = async () => {
      try {
        await axios.post(`/api/patient/signout`);
        router.push("/");
      } catch (error) {
        console.error("Sign-out error:", error);
      }
    };
    const getProfileAvatar = computed(() => {
      return localStorage.getItem("patientProfile");
    });
    const getGivenName = computed(() => {
      return store.state.userLogged.substring(
        store.state.userLogged.indexOf(",") + 2
      );
    });

    return {
      isDropdownOpen,
      toggleDropdown,
      handleLogout,
      getProfileAvatar,
      itemList,
      getGivenName,
    };
  },
};
</script>
